import { Modal, ModalHeader, ModalBody, ModalFooter } from './Modal'
import { FormField, TextInput, TextArea } from './FormField'

interface FormModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
  title: string
  submitLabel?: string
  cancelLabel?: string
  name: string
  onNameChange: (value: string) => void
  nameLabel?: string
  namePlaceholder?: string
  description?: string
  onDescriptionChange?: (value: string) => void
  descriptionLabel?: string
  descriptionPlaceholder?: string
  showDescription?: boolean
  isProcessing?: boolean
  error?: string
  children?: React.ReactNode
}

export function FormModal({
  isOpen,
  onClose,
  onSubmit,
  title,
  submitLabel = 'Submit',
  cancelLabel = 'Cancel',
  name,
  onNameChange,
  nameLabel = 'Name',
  namePlaceholder = 'Enter name',
  description = '',
  onDescriptionChange,
  descriptionLabel = 'Description',
  descriptionPlaceholder = 'Enter description (optional)',
  showDescription = true,
  isProcessing = false,
  error,
  children
}: FormModalProps) {
  const handleSubmit = () => {
    if (name.trim()) {
      onSubmit()
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="medium">
      <ModalHeader title={title} onClose={onClose} />
      <ModalBody>
        <FormField label={nameLabel} htmlFor="form-name" required>
          <TextInput
            id="form-name"
            value={name}
            onChange={onNameChange}
            onKeyDown={(e) => e.key === 'Enter' && name.trim() && handleSubmit()}
            placeholder={namePlaceholder}
            autoFocus
          />
        </FormField>

        {showDescription && onDescriptionChange && (
          <FormField label={descriptionLabel} htmlFor="form-description">
            <TextArea
              id="form-description"
              value={description}
              onChange={onDescriptionChange}
              placeholder={descriptionPlaceholder}
            />
          </FormField>
        )}

        {children}

        {error && (
          <div style={{ color: '#e74c3c', marginTop: '1rem' }}>
            {error}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <button onClick={onClose} className="cancel-btn" disabled={isProcessing}>
          {cancelLabel}
        </button>
        <button 
          onClick={handleSubmit} 
          className="submit-btn" 
          disabled={!name.trim() || isProcessing}
        >
          {submitLabel}
        </button>
      </ModalFooter>
    </Modal>
  )
}
